import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faClock, faList, faExclamationTriangle, faTh, faUser, faPhone, faEnvelope, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import { Paginador } from '../../Paginacion/Paginador';

export const Citas = ({ citasList, executeConsulta, setExecuteConsulta, origen }) => {

    const [filtroCitas, setFiltroCitas] = useState('TODAS');
    const [vistaModo, setVistaModo] = useState('LIST');
    const [paginacion, setPaginacion] = useState({
        totalElementos: '0',
        elementosPorPagina: '12',
        paginaActual: '1'
    });

    useEffect(() => {
        const filtered = (filtroCitas === 'TODAS')
            ? citasList
            : citasList.filter(cita => cita.estado === filtroCitas);

        setPaginacion(prev => ({
            ...prev,
            totalElementos: filtered.length.toString()
        }));
    }, [citasList, filtroCitas]);

    useEffect(() => {
        setPaginacion(prev => ({
            ...prev,
            paginaActual: '1'
        }));
    }, [filtroCitas]);

    const getStatusGradient = (estado) => {
        switch (estado) {
            case 'PASADA': return 'linear-gradient(135deg, #4b5563, #9ca3af)'; // Gray to Slate
            case 'HOY': return 'linear-gradient(135deg, #FF512F, #DD2476)'; // Sunrise: Orange-Red to Pink
            case 'FUTURA': return 'linear-gradient(135deg, #1A2980, #26D0CE)'; // Aqua Marine: Deep Blue to Cyan
            default: return 'linear-gradient(135deg, #232526, #414345)'; // Midnight: Dark Gray
        }
    };

    const getFilteredCitas = () => {
        const filtered = (filtroCitas === 'TODAS') ? citasList : citasList.filter(cita => cita.estado === filtroCitas);
        const indexPage = (parseInt(paginacion.paginaActual, 10) - 1) * parseInt(paginacion.elementosPorPagina, 10);
        const limitPage = indexPage + parseInt(paginacion.elementosPorPagina, 10);
        return filtered.slice(indexPage, limitPage);
    };

    return (
        <div className="div-mis-citas-container">
            <div className="div-mis-citas-header mb-4">
                <h4 className="mb-3">{origen === 'AGENDA' ? 'Mis citas programadas:' : ''}</h4>
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div className="div-filtros-citas">
                        {['TODAS', 'HOY', 'PASADA', 'FUTURA'].map((filtro) => (
                            <button
                                key={filtro}
                                className={`btn-filtro-cita ${filtroCitas === filtro ? 'active' : ''}`}
                                onClick={() => setFiltroCitas(filtro)}
                            >
                                {filtro === 'TODAS' ? 'Todas' : filtro.charAt(0) + filtro.slice(1).toLowerCase()}
                            </button>
                        ))}
                    </div>
                    <div className="d-flex align-items-center">
                        <div className="btn-group me-3" role="group" aria-label="Cambiar vista">
                            <button
                                type="button"
                                className={`btn btn-sm ${vistaModo === 'CARD' ? 'icon-list-cita-active' : 'icon-list-cita'}`}
                                onClick={() => setVistaModo('CARD')}
                                title="Vista de tarjetas"
                            >
                                <FontAwesomeIcon icon={faTh} />
                            </button>
                            <button
                                type="button"
                                className={`btn btn-sm ${vistaModo === 'LIST' ? 'icon-list-cita-active' : 'icon-list-cita'} `}
                                onClick={() => setVistaModo('LIST')}
                                title="Vista de lista"
                            >
                                <FontAwesomeIcon icon={faList} />
                            </button>
                        </div>
                        <span className="me-2" style={{ fontSize: '0.9rem', color: '#64748b' }}>Mostrar:</span>
                        <select className="form-select form-select-sm" style={{ width: 'auto', cursor: 'pointer', borderColor: '#e2e8f0' }} value={paginacion.elementosPorPagina} onChange={(e) => {
                            setPaginacion(prev => ({
                                ...prev,
                                elementosPorPagina: e.target.value,
                                paginaActual: '1'
                            }));
                        }}>
                            <option value="6">6</option>
                            <option value="12">12</option>
                            <option value="24">24</option>
                            <option value="48">48</option>
                        </select>
                    </div>
                </div>
            </div>
            {vistaModo === 'CARD' ? (
                <div className="row m-0">
                    {getFilteredCitas().length > 0 ? (
                        getFilteredCitas().map((cita) => (
                            <div key={cita.id} className="col-12 col-md-6 col-lg-4 mb-3">
                                <div className="card-cita">
                                    <div className="card-cita-header" style={{ background: getStatusGradient(cita.estado) }}>
                                        <div className="card-cita-date">
                                            <FontAwesomeIcon icon={faCalendar} className="me-2" />
                                            {cita.fecha}
                                        </div>
                                        <div className="card-cita-time">
                                            <FontAwesomeIcon icon={faClock} className="me-2" />
                                            {cita.hora}
                                        </div>
                                    </div>
                                    <div className="card-cita-body">
                                        <h5 className="cita-cliente-name">{cita.cliente}</h5>
                                        <p className="cita-info"><span className="p-bold">Tel:</span> {cita.telefono}</p>
                                        <p className="cita-info"><span className="p-bold">Email:</span> {cita.correo}</p>
                                        {cita.observaciones && (
                                            <p className="cita-obs mt-2">
                                                <FontAwesomeIcon icon={faList} className="me-2 text-muted" />
                                                {cita.observaciones}
                                            </p>
                                        )}
                                    </div>
                                    <div className="card-cita-footer">
                                        <span className="badge-estado" style={{ background: getStatusGradient(cita.estado) }}>
                                            {cita.estado}
                                        </span>
                                    </div>
                                    {
                                        origen === 'AGENDA_ADMIN' && (
                                            <div className="card-cita-body-user">
                                                <p className="cita-info" style={{ color: '#063786ff' }}><span className="p-bold">Usuario:</span> {cita.usuario}</p>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center py-5">
                            <FontAwesomeIcon icon={faExclamationTriangle} size="3x" className="text-muted mb-3" />
                            <p className="p-label-form">No se encontraron citas en esta categoría.</p>
                        </div>
                    )}
                </div>
            ) : (
                <div className="table-profesionales">
                    <div className={origen === 'AGENDA_ADMIN' ? 'table-responsive-agenda' : 'table-responsive'}>
                        <table className="table table-hover align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>Cliente</th>
                                    <th>Fecha y Hora</th>
                                    <th>Contacto</th>
                                    {origen === 'AGENDA_ADMIN' && <th>Usuario</th>}
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getFilteredCitas().length > 0 ? (
                                    getFilteredCitas().map((cita) => (
                                        <tr key={cita.id}>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-placeholder me-2 bg-secondary text-white rounded-circle d-flex justify-content-center align-items-center flex-shrink-0" style={{ width: '35px', height: '35px' }}>
                                                        <FontAwesomeIcon icon={faUser} />
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold">{cita.cliente}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div><FontAwesomeIcon icon={faCalendar} className="me-1 text-muted" /> {cita.fecha}</div>
                                                <div className="small text-muted"><FontAwesomeIcon icon={faClock} className="me-1 text-muted" /> {cita.hora}</div>
                                            </td>
                                            <td>
                                                <div className="small text-muted">
                                                    <div><FontAwesomeIcon icon={faPhone} className="me-1" /> {cita.telefono}</div>
                                                    <div><FontAwesomeIcon icon={faEnvelope} className="me-1" /> {cita.correo}</div>
                                                </div>
                                            </td>
                                            {origen === 'AGENDA_ADMIN' && (
                                                <td>
                                                    <div className="small" style={{ color: '#063786ff', fontWeight: '500' }}>{cita.usuario}</div>
                                                </td>
                                            )}
                                            <td>
                                                <div>
                                                    <span className="badge-estado" style={{ background: getStatusGradient(cita.estado), padding: '5px 10px', borderRadius: '15px', color: 'white', fontSize: '0.8rem', display: 'inline-block', minWidth: '80px', textAlign: 'center' }}>
                                                        {cita.estado}
                                                    </span>
                                                </div>
                                                {cita.observaciones && (
                                                    <div className="small text-muted mt-1" style={{ maxWidth: '180px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={cita.observaciones}>
                                                        <FontAwesomeIcon icon={faStickyNote} className="me-1" /> {cita.observaciones}
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={origen === 'AGENDA_ADMIN' ? "5" : "4"} className="text-center py-5">
                                            <FontAwesomeIcon icon={faExclamationTriangle} size="2x" className="text-muted mb-2" />
                                            <p className="p-label-form mb-0">No se encontraron citas en esta categoría.</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <Paginador
                elementsPaginacion={paginacion}
                setElementsPaginacion={setPaginacion}
                setExecuteConsulta={setExecuteConsulta}
                executeConsulta={executeConsulta}
            />
        </div>
    );
};